module.exports = __webpack_public_path__ + "img/prairie-convergence.45678aa4.jpeg";